import { toSnakeCase } from '../format/string/to-snake-case'

/**
 * Convert the top-level keys of an object to snake_case. Does not recurse into
 * nested objects or arrays — every current caller only passes flat primitive
 * values. Keys already starting with `$` are left untouched (PostHog's own
 * reserved/protocol properties, e.g. $set).
 *
 * @param obj - The object whose keys to convert
 * @returns A new object with snake_case keys
 *
 * @example
 * toSnakeCaseKeys({ organizationId: '1', childCount: 2 })
 * // { organization_id: '1', child_count: 2 }
 */
export function toSnakeCaseKeys<T extends Record<string, unknown>>(obj: T): Record<string, unknown> {
  const result: Record<string, unknown> = {}
  for (const [key, value] of Object.entries(obj)) {
    result[key.startsWith('$') ? key : toSnakeCase(key)] = value
  }
  return result
}
